export const SET_CUSTOM_ORDER = 'SET_CUSTOM_ORDER';

export const setCustomOrder = (customOder) => ({
    type: SET_CUSTOM_ORDER,
    data: customOder,
});
